import { generateAsyncSagaWatcher } from '../../../utils';

import { EAgencyActions } from './enums';
import { IAgency } from './models';

export const agencySaga = generateAsyncSagaWatcher<IAgency>(EAgencyActions.GET_AGENCY);
